import React from "react";
import PropTypes from "prop-types";

import { Form } from "..";

export function FormShortText({
  id,
  name,
  description,
  value,
  required,
  errorMessage,
  disabled,
}) {
  return (
    <Form.Input
      name={id}
      label={name}
      description={description}
      defaultValue={value}
      fluid
      data-test="form-short-text"
      placeholder="Enter a value"
      required={required}
      errorMessage={errorMessage}
      disabled={disabled}
    />
  );
}

FormShortText.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
};

FormShortText.defaultProps = {
  description: "",
  value: "",
  required: true,
  errorMessage: "Please enter a value",
  disabled: false,
};

export default FormShortText;
